module.exports = __webpack_public_path__ + "img/area-chart-stepped-light-01.693e5548.jpg";